import { render, staticRenderFns } from "./attributions.vue?vue&type=template&id=6e7251e5&"
import script from "./attributions.vue?vue&type=script&lang=js&"
export * from "./attributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports